var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view13Wrapper shadowRadius"},[_c('div',{staticClass:"guideImage"},[_c('img',{staticClass:"imgBox",attrs:{"src":_vm.list.imgUrl,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }